module.exports = __webpack_public_path__ + "img/ico_extrato-financeiro-2.a5d127b6.svg";